/**
 * Toast Icons Configuration
 * Centralized icon system for toast messages
 */

export const TOAST_ICONS = {
    // Game actions
    DECLARATION: '🎴',
    MEDIA: '🎴',
    POINT_AND_MEDIA: '👑',
    JUEGO: '🃏',
    PAIRS: '💢',
    
    // Special events
    ASEO: '🧹',
    ASEO_SHINE: '✨',
    CAIDA_4: '💎',
    CAIDA_3: '🌟',
    BACIGA: '🎴',
    BACIGOTE: '💥',
    
    // Communication
    ENVIO: '📢',
    ACCEPT: '✅',
    REJECT: '❌',
    A_LA_MAYOR: '⚖️',
    CHIQUITA: '🔽',
    
    // Turn and flow
    TURN: '▶️',
    PASO: '⏭️',
    PASS: '🚫',
    
    // Scoring
    POINTS: '⭐',
    TEAM_SCORE: '🎯',
    WINNER: '🏆',
    CROWN: '👑',
    
    // Status
    WARNING: '⚠️',
    ERROR: '❌',
    INFO: 'ℹ️',
    SUCCESS: '✅',
    
    // Cards
    CARD: '🂠',
    WILDCARD: '🃏',
    
    // Special
    LAST_HAND: '⏰',
    SE_HAN_IDO: '💨',
    DEBUG: '🔧'
};

/**
 * Get icon for a declaration type
 */
export function getDeclarationIcon(declarationType) {
    const iconMap = {
        'pointAndMedia': TOAST_ICONS.POINT_AND_MEDIA,
        '31': TOAST_ICONS.JUEGO,
        'juego': TOAST_ICONS.JUEGO,
        'pairs': TOAST_ICONS.PAIRS,
        'media': TOAST_ICONS.MEDIA
    };
    return iconMap[declarationType] || TOAST_ICONS.DECLARATION;
}

/**
 * Get icon for caída type
 */
export function getCaidaIcon(caidaType) {
    if (caidaType?.includes('4')) return TOAST_ICONS.CAIDA_4;
    if (caidaType?.includes('3')) return TOAST_ICONS.CAIDA_3;
    return TOAST_ICONS.CAIDA_3;
}

/**
 * Format points for display
 */
export function formatPoints(points) {
    return `+${points} pts`;
}

/**
 * Format team display
 */
export function formatTeam(teamNumber) {
    return `Pareja ${teamNumber}`;
}

/**
 * Create separator for multi-part messages
 */
export const SEPARATOR = ' · ';

export default TOAST_ICONS;
